import { useTranslation } from 'react-i18next';

import 'components/desktop/Recipe/RecipeTabs/Components/IngredientTooltip/IngredientTooltip.scss';
import { JoinedIngredientType } from 'components/desktop/Recipe/RecipeTabs/recipeComputations';
import { IncorporationShare, relevanceType } from 'types/Recipe/Recipe';

const SeasonalityCell = (props: {
	relevanceType: string;
	joinedIngredients: JoinedIngredientType[];
	ingredientId: string;
	handleIncorporationShareChange: (shares: IncorporationShare[]) => void;
	calculateSeasonalityRelevanceArray: (
		mappedIngredients: JoinedIngredientType[],
		value: string,
		ingredientId?: string
	) =>
		| {
				segmentIndex: number;
				ingredientIndex: number;
				incorporationShare: any;
				ingredientId: any;
				unitId: string | null;
				quantity: number | null;
				index: number;
				relevanceType: relevanceType;
		  }[]
		| undefined;
}) => {
	const { t } = useTranslation();

	const handleRelevanceChange = (value: string) => {
		const array = props.calculateSeasonalityRelevanceArray(
			props.joinedIngredients,
			value,
			props.ingredientId || ''
		);
		array && props.handleIncorporationShareChange(array);
	};

	return (
		<div>
			<select
				className="form-select"
				aria-label="Seasonality Relevance"
				style={{ width: '7rem' }}
				value={props.relevanceType || relevanceType.Irrelevant}
				onChange={(e) => {
					handleRelevanceChange(e.target.value);
				}}
			>
				<option value={relevanceType.Required}>{t('seasonality:REQUIRED')}</option>
				<option value={relevanceType.Optional}>{t('seasonality:OPTIONAL')}</option>
				<option value={relevanceType.Irrelevant}>{t('seasonality:IRRELEVANT')}</option>
			</select>
		</div>
	);
};

export default SeasonalityCell;
